<template>
  <div>
    <tool
      :level="level"
      @search="onSearch"
      @reset="onReset"
    />
    <intercept-opration
      :count="selectedRowKeys.length"
      :total="dataSource.length"
      @cancel="cancelInterceptd"
      @mark="onMark"
      @delRecord="delHandler"
    />
    <div class="table_main">
      <a-table
        :columns="levelFormColumns"
        :data-source="dataSource"
        :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :pagination="false"
        :loading="loading"
        :custom-row="toDetail"
        @change="onChange"
      >
        <div
          slot="username"
          slot-scope="text, record, index"
          style="max-width: 140px; min-width: 80px;"
        >
          <div class="table_time">
            <p :class="['time_date', !record.isRead && 'read', formatDeveloper(record) === '--' ? 'font_normal' : '']">
              <other-tooltip
                col-key="username"
                :text="text || '--'"
                :index="index"
                :columns="formColumns"
              />
            </p>
            <p
              v-if="formatDeveloper(record) !== '--'"
              :class="['time_division developer', !record.isRead && 'read']"
            >
              {{ formatDeveloper(record) }}
            </p>
          </div>
        </div>
        <p
          slot="contact"
          slot-scope="text, record, index"
          :class="[!record.isRead && 'read']"
          style="width: 100px;"
        >
          <other-tooltip
            col-key="contact"
            :text="text || '--'"
            :index="index"
            :columns="formColumns"
          />
        </p>
        <!-- <p
          slot="form_name"
          slot-scope="text, record"
          :class="['form_belong', !record.isRead && 'read']"
          v-text="text"
        /> -->
        <p
          slot="form_name"
          slot-scope="text, record, index"
          :class="['form_belong', !record.isRead && 'read']"
        >
          <other-tooltip
            col-key="form_name"
            :text="text || '--'"
            :index="index"
            :columns="formColumns"
          />
        </p>
        <div
          slot="ip"
          slot-scope="text, record"
          :class="[!record.isRead && 'read']"
        >
          <div class="table_time">
            <p>
              {{ text }}
            </p>
            <p
              v-if="record.from_ip_city"
              class="time_division developer"
            >
              {{ record.from_ip_city }}
            </p>
          </div>
        </div>
        <p
          slot="url"
          slot-scope="text, record, index"
          :class="['form_url', !record.isRead && 'read']"
          @click.stop="toHref(text)"
        >
        <other-tooltip
            col-key="from_url"
            :text="text || '--'"
            :index="index"
            :columns="formColumns"
          />
        </p>
        <div
          slot="addtime"
          slot-scope="text, record"
          style="width: 100px;"
        >
          <div class="table_time">
            <p :class="['time_date', !record.isRead && 'read']">
              {{ formatUpTime(text, 1) }}
            </p>
            <p
              v-if="text"
              :class="['time_division', !record.isRead && 'read']"
            >
              {{ formatUpTime(text, 2) }}
            </p>
          </div>
        </div>
      </a-table>
      <!-- 分页 -->
      <pagination
        v-if="totalCount > 0"
        ref="pagination"
        :pagination="pagination"
        @change="handlePage"
      />
    </div>
    <template>
      <info-detail
        :id="detailID"
        :visible.sync="showDetailVisible"
        :init="fetchList"
        @cancel="toCancel"
      />
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
import Tool from './InterceptTool'
import Pagination from '@/components/pc/Pagination'
import infoDetail from '../components/Detail'
import interceptOpration from './InterceptBtns'
import { mapState, mapActions, mapMutations } from 'vuex'
import { formatUpTime, formatDeveloper, formatField } from '../common'
import OtherTooltip from '../components/OtherTooltip'

const ALL_STATUS = 3

export default {
  components: {
    Tool,
    Pagination,
    infoDetail,
    interceptOpration,
    OtherTooltip
  },
  props: {
    level: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selectedRowKeys: [],
      showDetailVisible: false,
      detailID: 0
    }
  },
  computed: {
    ...mapState('smart/submit', ['formColumns']),
    ...mapState('smart/intercept', ['interceptList', 'loading', 'totalCount', 'pagination']),
    dataSource () {
      return this.interceptList.map(item => {
        item.key = item.id
        return item
      })
    },
    levelFormColumns () {
      let aColums = [].concat(...this.formColumns)
      aColums.forEach((item, index) => {
        // 过滤状态
        if (item.key === 'status') {
          aColums.splice(index, 1)
        }
        // 过滤掉开发人员
        /* if (item.key === 'username' && this.level === 0) {
          aColums.splice(index, 1)
        } */
      })
      return aColums
    },
    delTips () {
      return this.$t('message["967"]').split('|')
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    ...mapActions('smart/intercept', ['fetchDataList', 'toMarkRead', 'cancelInterceptStatus']),
    ...mapActions('smart/submit', ['fetchRecordDetail', 'delRecords']),
    ...mapMutations('smart/intercept', ['SET_PAGINATION', 'SET_LIST_READ']),
    formatDeveloper,
    formatUpTime,
    formatField,
    // 请求拦截列表数据
    async fetchList (obj = {}) {
      let params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSizesType[this.pagination.pageSize],
        status: ALL_STATUS,
        ...obj
      }
      await this.fetchDataList(params)
      this.$router.push({ query: params })
    },
    // 排序
    onChange (pagination, filters, sorter) {
      let params = Object.assign({}, { sortkey: '' }, { sorttype: 0 })
      if (sorter.order) {
        const { order } = sorter
        let sort = 0
        const orderTable = { 'ascend': 1, 'descend': 2 }
        sort = orderTable[order]
        params = Object.assign(params, { sortkey: sorter.columnKey }, { sorttype: sort })
      }
      this.fetchList({
        ...this.$route.query,
        page: pagination.currentPage,
        limit: pagination.pageSize,
        ...params
      })
    },
    toDetail (record, index) {
      const _this = this
      return {
        on: {
          click: () => {
            const { id, isRead } = record
            !isRead && _this.markListRead(index, { ids: id })
            _this.$set(_this._data, 'detailID', id)
            _this.fetchDetail({ id })
          }
        }
      }
    },
    async fetchDetail (params) {
      await this.fetchRecordDetail(params)
      this.showDetailVisible = true
    },
    onSearch (params) {
      this.SET_PAGINATION({ key: 'currentPage', value: 1 })
      this.fetchList(params)
      this.clearSelectedRowKeys()
    },
    onReset () {
      this.$router.push({ query: {} })
      this.fetchList()
      this.clearSelectedRowKeys()
    },
    clearSelectedRowKeys () {
      this.selectedRowKeys = []
    },
    resetFetchList (info = {}) {
      const { currentPage, pageSize } = info
      // 请求数据
      this.fetchList({
        ...this.$route.query,
        page: currentPage,
        limit: this.pagination.pageSizesType[pageSize]
      })
    },
    handlePage (pagination) {
      const { currentPage, pageSize } = pagination
      this.SET_PAGINATION({ key: 'currentPage', value: currentPage })
      this.resetFetchList({ currentPage, pageSize })
      this.selectedRowKeys = []
    },
    onSelectChange (value) {
      this.selectedRowKeys = value
    },
    async markListRead (index = 0, params = {}) {
      const chain = await this.toMarkRead(params)
      const _this = this
      chain.onSuccess(res => {
        _this.SET_LIST_READ({ index, params })
      })
        .fetch()
    },
    // 批量标记已读
    onMark () {
      let selectedLength = this.selectedRowKeys.length
      if (selectedLength === 0) {
        this.$message.warning(this.$t('message["873"]'))
        return
      }
      let params = this.selectedRowKeys.join(',')
      this.markListRead(-1, { ids: params })
    },
    // 批量取消拦截
    cancelInterceptd () {
      let selectedLength = this.selectedRowKeys.length
      if (selectedLength === 0) {
        this.$message.warning(this.$t('message["873"]'))
      } else {
        let params = this.selectedRowKeys.join(',')
        this.cacelInterceptedData({ ids: params })
      }
    },
    async cacelInterceptedData (params) {
      const chain = await this.cancelInterceptStatus(params)
      const _this = this
      chain.onSuccess(res => {
        _this.$message.success(this.$t('message["897"]'))
        _this.fetchList()
      })
        .fetch()
    },
    toCancel (value) {
      let params = { ids: value.formid }
      this.cacelInterceptedData(params)
    },
    // 点击【来源地址】跳转
    toHref (url) {
      if (url || url !== '') {
        window.open(url)
      }
    },
    delHandler () {
      // debugger
      const that = this
      const { selectedRowKeys } = this
      const len = selectedRowKeys.length
      // this.delRec()
      if (len > 0) {
        this.$confirm({
          iconType: 'info-circle',
          title: this.$t('message["972"]'),
          content: <div>{this.delTips[0]}<span class="confitm_warning">{this.delTips[1]}</span>{this.delTips[2]}</div>,
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          closable: true,
          onOk: () => {
            that.delRec()
          }
        })
      }
    },
    async delRec () {
      const chain = await this.delRecords({ ids: this.selectedRowKeys })
      // console.log(this.selectedRowKeys)
      chain.onSuccess(raw => {
        this.$message.success(this.$t('message["965"]') + '！')
        this.selectedRowKeys = []
        this.fetchList()
      })
        .fetch()
    }
  }
}
</script>

<style scoped lang="scss">
.table_time {
  .time_division, .time_date {
    font-size: 12px;
    height: 16px;
  }
  .developer {
    margin-top: 4px;
  }
  .time_division {
    color: #999;
    line-height: 16px;
  }
  .font_normal {
    font-size: 14px;
    color: #333
  }
}
.table_main::v-deep  {
  .ant-table-row:hover {
    cursor: pointer;
  }
  .ant-checkbox-wrapper {
    margin-bottom: 0;
  }
}
.form_url {
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: $primary-color;
}
.read {
  font-weight: 600
}
.form_belong {
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
